import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AgriLinkDealsNearby from './AgriLinkDealsNearby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle, faVideo, faImages, faMapMarkerAlt, faHistory,
  faRobot, faUserTie, faPhone
} from '@fortawesome/free-solid-svg-icons';

const dummyAgriProducts = [
  {
    id: 1,
    title: "Fresh Organic Tomatoes",
    brief: "Locally grown, pesticide-free, fresh tomatoes.",
    category: "Vegetables",
    location: "Mumbai",
    hasOffer: true,
    image: "/api/downloads/agri-products/tomatoes.jpg",
  },
  {
    id: 2,
    title: "Premium Alphonso Mangoes",
    brief: "Sweet and juicy Alphonso mangoes, freshly harvested.",
    category: "Fruits",
    location: "Ratnagiri",
    hasOffer: false,
    image: "/api/downloads/agri-products/mangoes.jpg",
  },
  {
    id: 3,
    title: "Organic Turmeric Powder",
    brief: "High-quality turmeric powder from local farms.",
    category: "Spices",
    location: "Erode",
    hasOffer: true,
    image: "/api/downloads/agri-products/turmeric.jpg",
  },
  {
    id: 4,
    title: "Free-range Eggs",
    brief: "Fresh free-range chicken eggs, packed daily.",
    category: "Poultry",
    location: "Bengaluru",
    hasOffer: false,
    image: "/api/downloads/agri-products/eggs.jpg",
  },
];

const categories = [
  "Vegetables", "Fruits", "Spices", "Dairy", "Poultry", "Fishery", "Seeds & Nursery", "Fertilizers & Feed"
];

const AgriLinkNearbyDeals = () => {
  const [filters, setFilters] = useState({
    category: '',
    location: '',
    keywords: '',
    hasOffer: false,
  });
  const [results, setResults] = useState([]);
  const [nearbyClicked, setNearbyClicked] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    const filtered = dummyAgriProducts.filter(product =>
      (!filters.category || product.category === filters.category) &&
      (!filters.location || product.location.toLowerCase().includes(filters.location.toLowerCase())) &&
      (!filters.hasOffer || product.hasOffer) &&
      (!filters.keywords || product.title.toLowerCase().includes(filters.keywords.toLowerCase()))
    );
    setResults(filtered);
  };

  return (
    <div className="w-full p-6 max-w-6xl mx-auto bg-black text-white border border-green-500 rounded shadow">
      <h2 className="text-lg lg:text-2xl font-bold mb-6 text-yellow-200">Explore Agri Product Nearby Availability</h2>

      {/* Filters */}
      <div className="flex flex-col lg:flex-row gap-4 mb-2">
        {/* Category Dropdown */}
        <select
          onChange={(e) => setFilters({ ...filters, category: e.target.value })}
          className="border text-black p-2 rounded h-10"
        >
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        {/* Location Input */}
        <input
          type="text"
          placeholder="Location"
          onChange={(e) => setFilters({ ...filters, location: e.target.value })}
          className="border p-2 rounded"
        />

        {/* Keywords Input */}
        <input
          type="text"
          placeholder="Keywords"
          onChange={(e) => setFilters({ ...filters, keywords: e.target.value })}
          className="border p-2 rounded"
        />

        {/* Offers Only Checkbox */}
        <label className="flex items-center space-x-2 col-span-2 lg:col-span-1">
          <input
            type="checkbox"
            onChange={(e) => setFilters({ ...filters, hasOffer: e.target.checked })}
          />
          <span className='text-white'>Show Offers Only</span>
        </label>
      </div>

      {/* Search & Nearby Buttons */}
      <div className="flex flex-row justify-center mb-6 space-x-4">
        <button 
          onClick={handleSearch}
          className="bg-blue-600 text-white px-6 py-2 w-40 rounded-full hover:bg-blue-700 transition"
        >
          Search
        </button>

        <button 
          onClick={() => setNearbyClicked(!nearbyClicked)}
          className="bg-green-600 text-white w-60 px-6 py-2 rounded-full hover:bg-green-700 transition"
        >
          Nearby Deals
        </button>
      </div>

      {/* Results */}
      <div className="mt-8 space-y-4">
        {results.map(product => (
          <div key={product.id} className="bg-black border border-green-500 p-4 rounded shadow-md flex flex-col md:flex-row gap-4">
            <img src={product.image} alt={product.title} className="w-full md:w-40 h-28 object-cover rounded" />
            
            <div className="flex-1">
              <h3 className="text-lg lg:text-xl font-bold text-yellow-200">{product.title}</h3>
              <p className="text-white mb-4">{product.brief}</p>

              {/* Action Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 text-sm place-items-center">
                {[
                  { label: 'View Details', icon: faInfoCircle, path: 'details', color: 'blue' },
                  { label: 'Video', icon: faVideo, path: 'video', color: 'indigo' },
                  { label: 'Photos', icon: faImages, path: 'photos', color: 'green' },
                  { label: 'Locality', icon: faMapMarkerAlt, path: 'locality', color: 'yellow' },
                  { label: 'History', icon: faHistory, path: 'history', color: 'red' },
                  { label: 'Ask AI', icon: faRobot, path: 'ask-ai', color: 'purple' },
                  { label: 'Contact Seller', icon: faPhone, path: 'contact-seller', color: 'teal' },
                  { label: 'Contact Agent', icon: faUserTie, path: 'contact-agent', color: 'pink' },
                ].map(({ label, icon, path, color }) => (
                  <button
                    key={path}
                    onClick={() => navigate(`/product/${product.id}/${path}`)}
                    className={`flex items-center justify-start gap-2 bg-${color}-500 hover:bg-${color}-600 text-white px-3 py-2 rounded transition-all duration-200`}
                  >
                    <FontAwesomeIcon icon={icon} />
                    <span>{label}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {nearbyClicked && <AgriLinkDealsNearby />}
    </div>
  );
};

export default AgriLinkNearbyDeals;
